module.exports = __webpack_public_path__ + "img/notifications-icon.05c63fda.svg";